"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "card card-api-conult-dead-component",
    class: "".concat(_vm.list.length ? _vm.colorClass : "")
  }, [_c("div", {
    staticClass: "card-header"
  }, [_c("div", {
    staticClass: "col-detail-header"
  }, [_c("h3", {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c("div", {
    staticClass: "card-content"
  }, [!_vm.list.length && !_vm.load ? _c("div", {
    staticClass: "content-text-message"
  }, [_c("img", {
    attrs: {
      src: require("@/assets/images/icon-checked-grenn.png")
    }
  }), _vm._v(" "), _c("h1", [_vm._v("\n        Todos os serviços estão operando com sucesso\n      ")])]) : _c("div", {
    staticClass: "columns row-tables"
  }, [!_vm.load && _vm.total ? _c("div", {
    class: "column is-one-quarter col-".concat(_vm.colorClass)
  }, [_vm._v("\n        " + _vm._s(_vm.list.length) + "\n      ")]) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "column col-table"
  }, [_c("b-table", {
    attrs: {
      data: _vm.list,
      selected: _vm.selected,
      loading: _vm.load
    },
    on: {
      "update:selected": function updateSelected($event) {
        _vm.selected = $event;
      }
    }
  }, [[_c("b-table-column", {
    attrs: {
      field: "service",
      label: "Serviço"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(_vm._f("toUpperCase")(props.row.service || props.row.serviceName || "--")) + "\n            ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "consumer",
      label: "Consumidor"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(_vm._f("translateConsumer")(props.row.consumer || props.row.consumerGroup)) + "\n            ")];
      }
    }])
  }), _vm._v(" "), _c("b-table-column", {
    attrs: {
      field: "totalErrors",
      label: "QTD"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_vm._v("\n              " + _vm._s(props.row.totalErrors || props.row.quantidade) + "\n            ")];
      }
    }])
  }), _vm._v(" "), !_vm.withoutHttpStatusColumn ? _c("b-table-column", {
    attrs: {
      field: "http_status",
      label: _vm.protocolColumnName,
      centered: ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(props) {
        return [_c("small", {
          staticClass: "type-call",
          class: {
            error: props.row.http_status >= 400,
            success: props.row.http_status < 300
          },
          attrs: {
            title: props.row.http_status
          }
        }, [_vm._v(_vm._s(props.row.http_status))])];
      }
    }], null, false, 1172346875)
  }) : _vm._e()]], 2)], 1)])])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;